export default {
  PAGE_SIZE: 10
}
